import React, { useMemo } from 'react'
import Forms from './Forms'
import { useLocation } from 'react-router'
import MiscellaneousFormsPage from '../MiscRecords/MiscellaneousFormsPage'

const FormsWrapper = (props) => {
  const location = useLocation()
  const { sublinks } = props

  const isMiscRecordsType = useMemo(() => {
    const parts = location.pathname.split('/')
    const sublink = sublinks.find(x => x.parameter === parts[parts.length - 1])
    if (sublink) {
      return sublink.IsMiscRecordsType
    } else {
      return false
    }
  }, [location, sublinks])

  if (isMiscRecordsType) return <MiscellaneousFormsPage {...props} />

  return <Forms {...props} />
}

export default FormsWrapper
